import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a2be40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between card-title m-0 w-100" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_8 = { class: "col-lg-8 fv-row" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  class: "tab-pane fade active show",
  id: "kt_pos_food_content_5",
  role: "tabpanel"
}
const _hoisted_12 = { class: "d-flex flex-wrap d-grid gap-5 gap-xxl-20 m-5" }
const _hoisted_13 = { class: "card-body text-center pb-4 mb-4 position-relative" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_17 = {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "indicator-label" }
const _hoisted_20 = { class: "indicator-progress" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate(_ctx.title)), 1)
      ])
    ]),
    (_openBlock(), _createElementBlock("div", {
      class: "collapse show",
      key: _ctx.formKey
    }, [
      _createVNode(_component_Form, {
        class: "form",
        "validation-schema": _ctx.attachmentSchema,
        onSubmit: _ctx.onSubmitCreateAttachment
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.translate(_ctx.title)), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Field, {
                  type: "file",
                  accept: "image/*,.pdf,application/pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,",
                  name: "attachments",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('Upload Attachment'),
                  multiple: _ctx.multiple,
                  ref: "attachmentRef",
                  onChange: _ctx.onFileChange
                }, null, 8, ["placeholder", "multiple", "onChange"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ErrorMessage, { name: "attachments" })
                  ])
                ])
              ])
            ]),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedImages, (imageSrc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "card card-flush"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      src: imageSrc.name,
                      alt: "Preview",
                      class: "rounded-3 mb-4 w-150px h-150px w-xxl-200px h-xxl-200px"
                    }, null, 8, _hoisted_14),
                    _createElementVNode("p", {
                      onClick: ($event: any) => (_ctx.removeImage(imageSrc)),
                      class: "remove-btn"
                    }, " ✘ ", 8, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.translate('discard')), 1),
            _createElementVNode("button", {
              type: "submit",
              id: "kt_account_profile_details_submit",
              ref: "submitButton",
              class: "btn btn-primary",
              disabled: _ctx.disabledBtn
            }, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('saveChanges')), 1),
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                _hoisted_21
              ])
            ], 8, _hoisted_18)
          ])
        ]),
        _: 3
      }, 8, ["validation-schema", "onSubmit"])
    ]))
  ]))
}